import { useSelector, useDispatch } from 'react-redux';

import app from 'app/config/app';
import FilterValues from 'core/filter/FilterValues';
import { deleteFilterParams } from 'app/features/partner-countries/partnerCountrySlice';

export default function PartnerCountryFilterValues() {
  const dispatch = useDispatch();

  const { params } = useSelector((state) => state.partnerCountries.index);

  const handleOnRemoveFilter = (key) => {
    dispatch(deleteFilterParams(key));
  };

  return (
    <FilterValues
      value={params}
      onRemoveFilter={handleOnRemoveFilter}
      ignoreKeys={app.ignoreFilterKeys}
    />
  );
}
